<div class="p-grid">
    <div class="p-col-12">

        <p-toast></p-toast>

        <div class="card">
            <p-toolbar styleClass="p-mb-4">
                <ng-template pTemplate="left">
                    <button pButton pRipple label="{{ 'label.novo' | translate }}" icon="pi pi-plus" class="p-button-success p-mr-2 p-mb-2" (click)="openNew()" *ngIf="permiteAcao===true"></button>
                </ng-template>

                <ng-template pTemplate="right">
                    <button pButton pRipple label="{{ 'label.exportar' | translate }}" icon="pi pi-upload" class="p-button-help p-mb-2" (click)="downloadFile()"></button>
                </ng-template>
            </p-toolbar>

            <p-table #dt [value]="usuarios" [columns]="cols" [rows]="10" [paginator]="true" [globalFilterFields]="['nmeUsuario','dscEmail', 'empresa.nmeEmpresa', 'aplicacao.nmeAplicacao', 'perfil.nmePerfil','dtaCriacao', 'status']"
                     [(selection)]="selectedUsuarios" [rowHover]="true" dataKey="id"
                     styleClass="p-datatable-customers"
                     currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">
                        <h5 class="p-m-0">{{ 'usuario.titulo' | translate }}</h5>
                        <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search..." />
                    </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="dscEmail" style="width: 200px;">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'usuario.emailUsername' | translate }}
                                <p-sortIcon field="dscEmail"></p-sortIcon>
                                <p-columnFilter type="text" field="dscEmail" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="empresa.nmeEmpresa">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'empresa.label' | translate }}
                                <p-sortIcon field="empresa.nmeEmpresa"></p-sortIcon>
                                <p-columnFilter type="text" field="empresa.nmeEmpresa" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="aplicacao.nmeAplicacao">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'aplicacao.aplicacao' | translate }}
                                <p-sortIcon field="aplicacao.nmeAplicacao"></p-sortIcon>
                                <p-columnFilter type="text" field="aplicacao.nmeAplicacao" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="perfil.nmePerfil">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'perfil.label' | translate }}
                                <p-sortIcon field="perfil.nmePerfil"></p-sortIcon>
                                <p-columnFilter type="text" field="perfil.nmePerfil" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="nmeUsuario">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'usuario.nomeSacado' | translate }}
                                <p-sortIcon field="nmeUsuario"></p-sortIcon>
                                <p-columnFilter type="text" field="nmeUsuario" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="nroCpf">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'usuario.sacado' | translate }}
                                <p-sortIcon field="nroCpf"></p-sortIcon>
                                <p-columnFilter type="text" field="nroCpf" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="dtaCadastro">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'usuario.datacriacao' | translate }}
                                <p-sortIcon field="dtaCadastro"></p-sortIcon>
                                <p-columnFilter type="date" field="dtaCadastro" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="status">{{ 'label.situacao' | translate }}<p-sortIcon field="status"></p-sortIcon></th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-usuario>
                    <tr>
                        <td><span class="p-column-title">Usuario</span>
                            {{usuario.dscEmail}}
                        </td>
                        <td><span class="p-column-title">Empresa</span>
                            {{usuario.empresa.nmeEmpresa}}
                        </td>
                        <td><span class="p-column-title">Aplicacao</span>
                            {{usuario.aplicacao.nmeAplicacao}}
                        </td>
                        <td><span class="p-column-title">Perfil</span>
                            {{usuario.perfil.nmePerfil}}
                        </td>
                        <td><span class="p-column-title">Nome Usuario</span>
                            {{usuario.perfil.nmePerfil === 'CONSSACADO' ? usuario.nmeUsuario: ''}}
                        </td>
                        <td><span class="p-column-title">Documento</span>
                            {{ usuario.perfil.nmePerfil === 'CONSSACADO' ? formatarDocumento(usuario.nroCpf): ''}}
                        </td>
                        <td><span class="p-column-title">Data Criacao</span>
                            {{usuario.dtaCadastro | date: 'dd/MM/yyyy'}}
                        </td>
                        <td><span class="p-column-title">Status</span>
                            {{usuario.statusUsuario.nomStatusUsuario}}
                        </td>
                        <td>
                            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-mr-2" (click)="editUsuario(usuario)" *ngIf="permiteAcao===true"></button>
                            <button pButton pRipple icon="pi pi-check-circle" class="p-button-rounded p-button-success p-mr-2" (click)="deleteUsuario(usuario)" *ngIf="permiteAcao===true && usuario.statusUsuario.nomStatusUsuario === 'Ativo'"></button>
                            <button pButton pRipple icon="pi pi-check-circle" class="p-button-rounded p-button-error p-mr-2" (click)="deleteUsuario(usuario)" *ngIf="permiteAcao===true && usuario.statusUsuario.nomStatusUsuario === 'Inativo'"></button>
                            <button pButton pRipple icon="pi pi-envelope" class="p-button-rounded p-button-error p-mr-2" (click)="sendUpdatePassword(usuario)"  *ngIf="permiteAcao===true"></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                       {{ 'label.totalde' | translate }} {{usuarios ? usuarios.length : 0 }} {{ 'usuario.usuarios' | translate }}.
                    </div>
                </ng-template>
            </p-table>
        </div>

        <p-dialog [(visible)]="usuarioDialog" [style]="{width: '450px'}" header="{{ 'usuario.detalhes' | translate }}" [modal]="true" styleClass="p-fluid">
            <p-messages [value]="msgs"></p-messages>
            <ng-template pTemplate="content">
                <div class="p-field">
                    <label for="Empresa">{{ 'empresa.label' | translate }}</label>
                    <span class="p-float-label" >
                        <p-dropdown inputId="empresa" [options]="empresas" [(ngModel)]="empresa.codEmpresa" optionValue="codEmpresa" optionLabel="nmeEmpresa" [autoDisplayFirst]="false"  (onChange)="getAplicacaoEmpresa()" [readonly]="statusExibed"></p-dropdown>
                    </span>
                </div>
                <div class="p-field">
                    <label for="Empresa">{{ 'aplicacao.aplicacao' | translate }}</label>
                    <span class="p-float-label">
                        <p-dropdown inputId="aplicacao" [options]="aplicacoes" [(ngModel)]="aplicacao.codAplicacao" optionValue="codAplicacao" optionLabel="nmeAplicacao" [autoDisplayFirst]="false" [readonly]="statusExibed"></p-dropdown>
                    </span>
                </div>
                <div class="p-field">
                    <label for="Empresa">{{ 'perfil.label' | translate }}</label>
                    <span class="p-float-label">
                        <p-dropdown inputId="perfil" [options]="perfis" [(ngModel)]="perfil.codPerfil" optionValue="codPerfil" optionLabel="dscPerfil" [autoDisplayFirst]="false" (onChange)="getPerfilDocumento()"></p-dropdown>
                    </span>
                </div>
                <div class="p-field" *ngIf="habilitaDocumento===true">
                    <label for="name">{{ 'usuario.sacado' | translate }}</label>
                    <span class="p-float-label">
                        <input type="text" pInputText id="documento" [(ngModel)]="usuario.nroCpf" required [readonly]="statusExibed"/>
                        <br/>
                        <button  [style]="{width: '150px'}" pButton pRipple label="{{ 'usuario.pesquisarSacado' | translate }}" class="" (click)="pesquisaSacado()" *ngIf="statusExibed === false"></button>
                    </span>
                </div>
                <div class="p-field" *ngIf="habilitaDocumento===true">
                    <label for="name">{{ 'usuario.nomeSacado' | translate }}</label>
                     <span class="p-float-label">
                         <input type="text" pInputText id="nome" [(ngModel)]="usuario.nmeUsuario" required autofocus [readonly]="true"/>
                     </span>
                </div>
                <div class="p-field">
                    <label for="name">{{ 'usuario.emailUsername' | translate }}</label>
                    <input type="text" pInputText id="dscEmail" [(ngModel)]="usuario.dscEmail" required autofocus [readonly]="statusExibed"/>
                </div>
                
            </ng-template>
            <ng-template pTemplate="footer">
                <button pButton pRipple label="{{ 'label.cancelar' | translate }}" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
                <button pButton pRipple label="{{ 'label.salvar' | translate }}" icon="pi pi-check" class="p-button-text" (click)="saveBanco()"></button>
            </ng-template>
        </p-dialog>

        <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
    </div>
</div>

